'use client';

import { Stack, Box, Button, Text, Title, Paper, Divider } from '@mantine/core';
import { IconSend } from '@tabler/icons-react';
import MentorshipApplicationBasicInfo from '@/components/mentorshipApplication/MentorshipApplicationBasicInfo';
import { RequestQuestion } from '@/types/mentorship';

interface ReviewStepProps {
  mentorName: string;
  answersJson: RequestQuestion[];
  onSubmit: () => void;
  loading?: boolean;
}

export default function ReviewStep({
  mentorName,
  answersJson,
  onSubmit,
  loading = false
}: ReviewStepProps) {
  return (
    <Stack gap="xl">
      <Box>
        <Title order={2} mb="xs">
          Review Your Application
        </Title>
        <Text c="dimmed" size="sm">
          Please review your application before submitting to <Text component="span" fw={600} c="dark">{mentorName}</Text>.
        </Text>
      </Box>

      <Divider />

      <MentorshipApplicationBasicInfo 
        answersJson={answersJson}
      />

      <Paper p="md" radius="md" withBorder style={{ backgroundColor: 'var(--mantine-color-blue-0)' }}>
        <Stack gap="sm">
          <Text size="sm" fw={500}>
            Ready to submit?
          </Text>
          <Text size="xs" c="dimmed">
            Once submitted, your application will be reviewed by {mentorName}. You&apos;ll be notified via email when they respond.
          </Text>
          <Button 
            onClick={onSubmit} 
            size="lg" 
            fullWidth 
            loading={loading}
            leftSection={<IconSend size={18} />}
            mt="xs"
          >
            Submit Application
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
